//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[0,"ArrowSideOption",1,0],[0,"BodyOutputOption",1,0],[0,"CombineOption",1,0],[0,"CopyOriginalOption",1,0],[0,"DistanceTolerance",1,0],[0,"Operation",1,0],[0,"ReverseTarget",1,0],[0,"ReverseTool",1,0],[0,"SurfaceShapeOption",1,0],[1,"TargetSelection",0,"ScCollector",0],[1,"ToolSelection",0,"ScCollector",0]],[],[]];
SPLM.Features.TrimAndExtendBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TrimAndExtendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TrimAndExtendBuilder.OperationType = Object.freeze({
    "UntilSelected" : "UntilSelected", "MakeCorner" : "MakeCorner"});

SPLM.Features.TrimAndExtendBuilder.ArrowSideType = Object.freeze({
    "Retain" : "Retain", "Delete" : "Delete"});

export default SPLM;